import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '../../mui/Core/index'
import { ContentCopyIcon } from '../../mui/Icons'
import { useHandleCopyContent } from '../../../hooks/UseCopyEmail/use-copy-email'

function CopyContentButton({ content, headerName }) {
  const { handleCopyContent } = useHandleCopyContent()
  const headerStyle = { mt: 1.5 }
  const buttonStyle = { ml: 2, cursor: 'pointer' }

  return (
    <Typography variant='h6' sx={headerStyle}>
      {headerName}
      {content && (
        <ContentCopyIcon
          fontSize='sm'
          sx={buttonStyle}
          onClick={() => {
            handleCopyContent(content)
          }}
        />
      )}
    </Typography>
  )
}

CopyContentButton.propTypes = {
  content: PropTypes.string,
  headerName: PropTypes.string,
}

export default CopyContentButton
